import { Component, Input, OnChanges, SimpleChange } from '@angular/core';

import { AppGlobals } from '@app/app.global';

@Component({
  selector: 'password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
  standalone: false,
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() public password: string;

  // private readonly colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];
  private readonly msgs = [
    'AUTH.PASSWORD_STRENGTH.WEAK',
    'AUTH.PASSWORD_STRENGTH.AVERAGE',
    'AUTH.PASSWORD_STRENGTH.GOOD',
    'AUTH.PASSWORD_STRENGTH.STRONG',
  ];
  private readonly types = [`danger`, `warning`, `info`, `success`];

  strength: number;
  msg: string;
  type: string;

  constructor(private appGlobals: AppGlobals) {}

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.password.currentValue;

    if (password) {
      const pwdStrength = this.checkStrength(password);
      const idx = Math.max(Math.min(~~(pwdStrength / 20) - 1, this.msgs.length - 1), 0);

      this.strength = pwdStrength;
      this.msg = this.msgs[idx];
      this.type = this.types[idx];
    } else {
      this.strength = 0;
      this.msg = '';
      this.type = '';
    }
  }

  private checkStrength(password: string) {
    const length = this.appGlobals.regex.length(this.appGlobals.minPasswordLength).test(password);
    const lowerLetter = this.appGlobals.regex.lowerCase.test(password);
    const upperLetter = this.appGlobals.regex.upperCase.test(password);
    const number = this.appGlobals.regex.number.test(password);
    const symbol = this.appGlobals.regex.symbol.test(password);

    let matchedCriteria = [length, lowerLetter, upperLetter, number, symbol].reduce(
      (total, passed) => total + (passed ? 1 : 0),
      0
    );
    matchedCriteria = Math.min(matchedCriteria, 5);
    let strength = password.length + matchedCriteria * 10;

    // short password
    strength = password.length <= 6 ? Math.min(strength, 20) : strength;

    // poor variety of characters
    strength = Math.min(strength, matchedCriteria * 20);

    return strength;
  }
}
